import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortsComplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Sorts complete",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.65921 16.0751C8.9521 16.368 8.9521 16.8429 8.65921 17.1358L6.23502 19.56C5.94213 19.8529 5.46725 19.8529 5.17436 19.56L3.71967 18.1053C3.42678 17.8124 3.42678 17.3375 3.71967 17.0446C4.01256 16.7517 4.48744 16.7517 4.78033 17.0446L5.70469 17.969L7.59855 16.0751C7.89145 15.7822 8.36632 15.7822 8.65921 16.0751Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.65921 10.2587C8.9521 10.5516 8.9521 11.0265 8.65921 11.3194L6.23502 13.7436C5.94213 14.0365 5.46725 14.0365 5.17436 13.7436L3.71967 12.2889C3.42678 11.996 3.42678 11.5211 3.71967 11.2282C4.01256 10.9353 4.48744 10.9353 4.78033 11.2282L5.70469 12.1526L7.59855 10.2587C7.89145 9.96584 8.36632 9.96584 8.65921 10.2587Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.65921 4.43842C8.9521 4.73131 8.9521 5.20619 8.65921 5.49908L6.23502 7.92327C5.94213 8.21617 5.46725 8.21617 5.17436 7.92327L3.71967 6.46858C3.42678 6.17569 3.42678 5.70082 3.71967 5.40792C4.01256 5.11503 4.48744 5.11503 4.78033 5.40792L5.70469 6.33228L7.59855 4.43842C7.89144 4.14553 8.36632 4.14553 8.65921 4.43842Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7734 18.0586C10.7734 17.6444 11.1092 17.3086 11.5234 17.3086H20.2507C20.6649 17.3086 21.0007 17.6444 21.0007 18.0586C21.0007 18.4728 20.6649 18.8086 20.2507 18.8086H11.5234C11.1092 18.8086 10.7734 18.4728 10.7734 18.0586Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7734 12.2422C10.7734 11.828 11.1092 11.4922 11.5234 11.4922H20.2507C20.6649 11.4922 21.0007 11.828 21.0007 12.2422C21.0007 12.6564 20.6649 12.9922 20.2507 12.9922H11.5234C11.1092 12.9922 10.7734 12.6564 10.7734 12.2422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7734 6.42188C10.7734 6.00766 11.1092 5.67188 11.5234 5.67188H20.2507C20.6649 5.67188 21.0007 6.00766 21.0007 6.42188C21.0007 6.83609 20.6649 7.17188 20.2507 7.17188H11.5234C11.1092 7.17188 10.7734 6.83609 10.7734 6.42188Z",
			fill: "currentColor"
		})
	]
});
export default SvgSortsComplete;
